<div class="left-modal">
  @if (loading) {
    <div class="loader"></div>
  }
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      <h1>{{'Filter scenes' | translate}}</h1>
      <form #form="ngForm" (ngSubmit)="filter()" novalidate>
        <div class="row">
          <div class="containerChecks">
            <div class="checkBoxCOnt">
              <input type="checkbox" name="script_scenes" [(ngModel)]="viewFilterArguments.script_scenes">
              <p class="checkbox">{{'Show script scenes' | translate}}</p>
            </div>
            <div class="checkBoxCOnt">
              <input type="checkbox" name="sub_scenes" [(ngModel)]="viewFilterArguments.sub_scenes">
              <p class="checkbox">{{'Show sub scenes' | translate}}</p>
            </div>
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label>{{'Scene type' | translate}}</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.scene_types"
              [list]="viewData.scene_types"
              [value]="'id'"
              [name]="'name'"
              [multiple]="true"
              [backTranslate]="true"
            ></app-dropdown>
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label>{{'Status' | translate}}</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.scene_status"
              [list]="viewData.scene_statuses"
              [value]="'id'"
              [name]="'name'"
              [multiple]="true"
              [backTranslate]="true"
            ></app-dropdown>
          </div>
          <div class="columns" [ngClass]="project.production_center_id == PRODUCTIONCOUNTRY.Brasil ? 'L-3 M-3 S-6' : 'L-4 M-4 S-6'">
            <label>{{'Chapter from' | translate}}</label>
            <input class="centered" type="text" name="chapter_from" [(ngModel)]="viewFilterArguments.chapter_from" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.number">
          </div>
          <div class="columns" [ngClass]="project.production_center_id == PRODUCTIONCOUNTRY.Brasil ? 'L-3 M-3 S-6' : 'L-4 M-4 S-6'">
            <label>{{'Chapter to' | translate}}</label>
            <input class="centered" type="text" name="chapter_to" [(ngModel)]="viewFilterArguments.chapter_to" placeholder="{{'Insert number' | translate}}" [pattern]="_gS.regex.number">
          </div>
          <div class="columns" [ngClass]="project.production_center_id == PRODUCTIONCOUNTRY.Brasil ? 'L-3 M-3 S-6' : 'L-4 M-4 S-6'">
            <label>{{'Day history' | translate}}</label>
            <input class="centered" type="text" name="day_of_history" [(ngModel)]="viewFilterArguments.day_of_history" placeholder="{{'Insert' | translate}}">
          </div>
          @if (project.production_center_id == PRODUCTIONCOUNTRY.Brasil) {
            <div class="L-3 M-3 S-6 columns">
              <label>{{'Change' | translate}}</label>
              <input class="centered" type="text" name="wd_change" [(ngModel)]="viewFilterArguments.wd_change" placeholder="{{'Insert' | translate}}">
            </div>
          }
          <div class="L-3 M-3 S-6 columns">
            <label>{{'Units' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.units"
              [list]="viewData.units"
              [value]="'id'"
              [name]="'unit_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-3 M-3 S-6 columns">
            <label>{{'Date from' | translate}}</label>
            <input class="centered" type="date" name="date_from" [(ngModel)]="viewFilterArguments.date_from" placeholder="{{'Insert date' | translate}}">
          </div>
          <div class="L-3 M-3 S-6 columns">
            <label>{{'Date to' | translate}}</label>
            <input class="centered" type="date" name="date_to" [(ngModel)]="viewFilterArguments.date_to" placeholder="{{'Insert date' | translate}}">
          </div>
          <div class="L-3 M-3 S-6 columns">
            <label>{{'Year' | translate}}</label>
            <input class="centered" type="text" name="year" [(ngModel)]="viewFilterArguments.year" placeholder="{{'#' | translate}}" [pattern]="_gS.regex.number" maxlength="4" minlength="4">
          </div>
          <div class="L-4 M-4 S-6 columns">
            <label>{{'Location / studio' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.location_studio_option_id"
              [list]="viewData.scene_loc_std_options"
              [value]="'id'"
              [name]="'name'"
              [backTranslate]="true"
              [showEmpty]="true"
              [placeholder]="'View both' | translate"
            ></app-dropdown>
          </div>
          <div class="L-4 M-4 S-6 columns">
            <label>{{'Interior / exterior' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.interior_exterior_option_id"
              [list]="viewData.scene_interior_exterior_options"
              [value]="'id'"
              [name]="'name'"
              [backTranslate]="true"
              [showEmpty]="true"
              [placeholder]="'View both' | translate"
            ></app-dropdown>
          </div>
          <div class="L-4 M-4 S-6 columns">
            <label>{{'Day / night' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.day_night_option_id"
              [list]="viewData.scene_day_night_options"
              [value]="'id'"
              [name]="'name'"
              [backTranslate]="true"
              [showEmpty]="true"
              [placeholder]="'View both' | translate"
            ></app-dropdown>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Location' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.locations"
              (appModelChange)="filterSets()"
              [list]="viewData.locations"
              [value]="'id'"
              [name]="'location_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Set' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.sets"
              [list]="filteredSets"
              [value]="'id'"
              [name]="'set_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'Characters' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.characters"
              [list]="listOfCharacters"
              [value]="'id'"
              [name]="'character_name'"
              [multiple]="true"
              [showSlideToggle]="true"
              [toggleSlideKey]="'include'"
            ></app-dropdown>
          </div>
          <div class="containerChecks AlignLeft">
            <div class="checkBoxCOnt">
              <input type="checkbox" name="only_selected" [(ngModel)]="viewFilterArguments.only_selected" [attr.disabled]="viewFilterArguments.at_least_one?'':null">
              <p class="checkbox">{{'Only selected characters' | translate}}</p>
            </div>
            <div class="checkBoxCOnt">
              <input type="checkbox" name="at_least_one" [(ngModel)]="viewFilterArguments.at_least_one" [attr.disabled]="viewFilterArguments.only_selected?'':null">
              <p class="checkbox">{{'At least one selected character' | translate}}</p>
            </div>
          </div>
          <div class="L-12 M-12 S-12 columns">
            <label>{{'extras' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.extras"
              [list]="viewData.extras_list"
              [value]="'id'"
              [name]="'character_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-6 M-6 S-12 columns">
            <label>{{'Element categories' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.element_categories"
              (appModelChange)="filterElements()"
              [list]="viewData.element_categories"
              [value]="'id'"
              [name]="'name'"
              [backTranslate]="true"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-6 M-6 S-12 columns">
            <label>{{'Elements' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.elements"
              [list]="filteredElements"
              [value]="'id'"
              [name]="'element_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-6 M-6 S-12 columns">
            <label>{{'Events' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.scene_events"
              [list]="viewData.events"
              [value]="'id'"
              [name]="'event_name'"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-6 M-6 S-12 columns">
            <label>{{'Event types' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.event_types"
              [list]="viewData.event_types"
              [value]="'id'"
              [name]="'name'"
              [backTranslate]="true"
              [multiple]="true"
            ></app-dropdown>
          </div>
          <div class="L-6 M-6 S-12 columns">
            <label>{{'Protection types' | translate}}**</label>
            <app-dropdown
              [(appModel)]="viewFilterArguments.protection_types"
              [list]="viewData.scene_protection_types"
              [value]="'id'"
              [name]="'name'"
              [backTranslate]="true"
              [multiple]="true"
            ></app-dropdown>
          </div>
          @if (viewData.tentatives.length > 0) {
            <div class="L-6 M-6 S-12 columns">
              <label>{{'Tentatives' | translate}}**</label>
              <app-dropdown
                [(appModel)]="viewFilterArguments.tentatives"
                [list]="viewData.tentatives"
                [value]="'name_tentative'"
                [name]="'name_tentative'"
                [multiple]="true"
              ></app-dropdown>
            </div>
          }
          <div class="containerChecks">
            <div class="checkBoxCOnt">
              <input type="checkbox" name="added" [(ngModel)]="viewFilterArguments.added">
              <p class="checkbox">{{'Only added scenes' | translate}}</p>
            </div>
            <div class="checkBoxCOnt">
              <input type="checkbox" name="establishing_shoot" [(ngModel)]="viewFilterArguments.establishing_shoot">
              <p class="checkbox">{{'Only establishing shoot' | translate}}</p>
            </div>
            <div class="checkBoxCOnt">
              <input type="checkbox" name="flashback" [(ngModel)]="viewFilterArguments.flashback">
              <p class="checkbox">{{'Only flashback' | translate}}</p>
            </div>
            <div class="checkBoxCOnt">
              <input type="checkbox" name="manualy_produced" [(ngModel)]="viewFilterArguments.manualy_produced">
              <p class="checkbox">{{'Only manually produced' | translate}}</p>
            </div>
          </div>
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Filter' | translate}}" [attr.disabled]="form.invalid?'':null">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>
